export default "__VITE_ASSET__85CL$520o9l61vPDDI3LOA__"